import axios from "axios";

export const state = {
    bookcategories: [],
};

export const getters = {
    bookcategories: state => state.bookcategories,
};

export const mutations = {
    setBookcategories(state, newValue) {
        state.bookcategories = newValue
    },
};

export const actions = {
    fetchBookcategories({ commit }) {
        axios.get('/bookcat').then(res => {
            commit('setBookcategories', res.data.bookcategories)
        })
    },
};
